export const ACCACCOUNT_LOADING = "ACCACCOUNT_LOADING";
export const ACCACCOUNT_RESET = "ACCACCOUNT_RESET";
export const GET_ACCACCOUNT = "GET_ACCACCOUNT";
export const GET_ACCACCOUNT_SUCCESS = "GET_ACCACCOUNT_SUCCESS";
export const GET_ACCACCOUNT_FAIL = "GET_ACCACCOUNT_FAIL";
export const DELETE_ACCACCOUNT = "DELETE_ACCACCOUNT"
export const DELETE_ACCACCOUNT_SUCCESS = "DELETE_ACCACCOUNT_SUCCESS"
export const DELETE_ACCACCOUNT_FAIL = "DELETE_ACCACCOUNT_FAIL"
export const UPDATE_ACCACCOUNT = "UPDATE_ACCACCOUNT"
export const UPDATE_ACCACCOUNT_SUCCESS = "UPDATE_ACCACCOUNT_SUCCESS"
export const UPDATE_ACCACCOUNT_FAIL = "UPDATE_ACCACCOUNT_FAIL"
export const ADD_NEW_ACCACCOUNT = "ADD_NEW_ACCACCOUNT"
export const ADD_ACCACCOUNT_SUCCESS = "ADD_ACCACCOUNT_SUCCESS"
export const ADD_ACCACCOUNT_FAIL = "ADD_ACCACCOUNT_FAIL"
export const GET_ACCACCOUNT_ONE = "GET_ACCACCOUNT_ONE";